/**
 * components/tabs/SettingsAccountPage.jsx
 *
 * upstox-073 — Settings → Account, rebuilt to the Claude Design handoff
 * (handover/design/settings-account-handoff-2026-10-08.html): four always-open sections, each a
 * two-column band — Profile, Connections, Risk limits, Watchlists. Layout only: every request,
 * payload, save rule and message is the page's own from before (see RiskLimitsTable.jsx for what
 * the design assumed and the server's rules).
 */

import React from 'react';
import { useUser } from '../../context/UserContext';
import { Band, SCOPED_CSS } from './SettingsParts';
import { ProfileContent, ConnectionsContent } from './SettingsConnections';
import RiskLimitsTable from './RiskLimitsTable';
import UpstoxWatchlistRules from './UpstoxWatchlistRules';   // upstox-051

const CSS = SCOPED_CSS + `
@container (max-width: 760px) { .sx2-grid3 { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; } }
@container (max-width: 480px) { .sx2-grid3 { grid-template-columns: minmax(0, 1fr) !important; } }
`;

export default function AccountPage({ initial = {}, listAccounts }) {
  const { user, isOwner } = useUser();
  return (
    <div className="sx2-root" data-account-page>
      <style>{CSS}</style>
      <Band id="profile" title="Profile" desc="The account you're signed in with.">
        <ProfileContent user={user} />
      </Band>
      <Band id="connections" title="Connections"
        desc={<>Brokers and data feeds. Your own API credentials are stored encrypted (Fernet; needs <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: 12 }}>ENCRYPTION_KEY</span> in the Railway env vars).</>}>
        <ConnectionsContent isOwner={isOwner} openCreds={initial.openCreds} />
      </Band>
      <Band id="risk" title="Risk limits"
        desc={['One set per account. A change applies from the next session that hasn’t started, never mid-session.',
          'Kite accounts are read-only: the terminal grades and warns, it never trades there.']}>
        <RiskLimitsTable listAccounts={listAccounts} initial={initial.risk} />
      </Band>
      <Band id="watchlists" title="Watchlists"
        desc="Automatic option-chain lists around the money, re-centred as the market moves. Saving re-centres at once. The fixed list is edited on the terminal itself.">
        <UpstoxWatchlistRules design initial={initial.watchlists} />
      </Band>
    </div>
  );
}
